import { z } from "zod";

export const AiGetFindReplaceTitleRequestBodySchema = z.object({
  find: z.string(),
  replacements: z.string().array(),
  querySelectors: z.string(),
});

export type AiGetFindReplaceTitleRequestBodyType = z.infer<
  typeof AiGetFindReplaceTitleRequestBodySchema
>;

export const AiGetFindReplaceTitleResponseSchema = z.object({
  title: z.string(),
});

export type AiGetFindReplaceTitleResponseBodyType = z.infer<
  typeof AiGetFindReplaceTitleResponseSchema
>;
